import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-timesheet-list',
  templateUrl: './timesheet-list.component.html',
  styles: []
})
export class TimesheetListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
